"use client";

import EventEmitter from "services/EventEmitter";
import Products from "services/api/Products";
import { Item } from "types/Item";

export default class ProductsStore {
	public static readonly instance = new this();
	protected readonly event = new EventEmitter();
	private products: Item[] = [];
	private isLoading: boolean = false;
	private error: Error | null = null;

	constructor() {
		this.fetchProducts();
	}

	private async fetchProducts() {
		try {
			this.isLoading = true;
			const response = await Products.getInstance().findAll();
			//@ts-ignore
			const products = response.filter((product: Item) => {
				return product.disponibilite !== "Epuisé";
			});
			//@ts-ignore
			this.products = products;
			this.isLoading = false;
			this.event.emit("change", this.products);
		} catch (error) {
			this.isLoading = false;
			this.error = error as Error;
			console.error("Error fetching products:", error);
			this.event.emit("error", error);
		}
	}

	public getProducts() {
		return this.products;
	}

	public isProductsLoading() {
		return this.isLoading;
	}

	public getError() {
		return this.error;
	}

	public async refreshProducts() {
		return this.fetchProducts();
	}

	public setProducts(products: Item[]) {
		this.products = products;
		this.event.emit("change", products);
	}

	public onChange(callback: (products: Item[]) => void) {
		this.event.on("change", callback);
		return () => {
			this.event.off("change", callback);
		};
	}

	public onError(callback: (error: Error) => void) {
		this.event.on("error", callback);
		return () => {
			this.event.off("error", callback);
		};
	}
}
